import type { MailboxInfo } from "owa-client-types";
import copilotSettingsStore from "../store/store";

export function isOldModelAddin(addinId: string, mailboxInfo: MailboxInfo): boolean {
    const store = copilotSettingsStore(mailboxInfo);
    return !!store.extensibility.addinInfoById.get(addinId)?.isOldModelAddin;
}
